export default __webpack_public_path__ + "static/media/4-2_image11@2x.f017f50a.png";